import { getTimeZonesList } from 'owa-datetime-store';

/**
 * Get the name of the given time zone as localized in the server's languge.
 * NOTE: This is likely in English and does not take the user's language into consideration.
 * If you need the client-localized name, use getTimeZoneDisplayName instead.
 *
 * E.g., (UTC-08:00) Pacific Time (US & Canada)
 *
 * @param timeZoneId
 */
export default function getTimeZoneNameInServerLanguage(timeZoneId: string): string {
    const timeZones = getTimeZonesList();

    for (const timeZone of timeZones) {
        if (timeZone.Value == timeZoneId) {
            return timeZone.Name;
        }
    }

    return timeZoneId || '';
}
